import api from './api';
import { PackageModel, CreatePackageModelData, UpdatePackageModelData } from '../types/packageModel';

export const optionModelService = {
  // Get all models for an option
  getByPackage: async (
    workspaceId: string,
    optionId: string
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models`
    );
    return response.data;
  },

  // Add a model to an option
  create: async (
    workspaceId: string,
    optionId: string,
    data: CreatePackageModelData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models`,
      data
    );
    return response.data;
  },

  // Add multiple models to an option
  createMultiple: async (
    workspaceId: string,
    optionId: string,
    models: CreatePackageModelData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models/bulk`,
      { models }
    );
    return response.data;
  },

  // Update a model in an option
  update: async (
    workspaceId: string,
    optionId: string,
    modelId: string,
    data: UpdatePackageModelData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models/${modelId}`,
      data
    );
    return response.data;
  },

  // Update multiple models in an option
  updateMultiple: async (
    workspaceId: string,
    optionId: string,
    models: UpdatePackageModelData[]
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models/bulk`,
      { models }
    );
    return response.data;
  },

  // Remove a model from an option
  delete: async (
    workspaceId: string,
    optionId: string,
    modelId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-options/${optionId}/models/${modelId}`
    );
    return response.data;
  }
};
